// extracted by mini-css-extract-plugin
export default {"wrapper":"ErrorPage_wrapper__FSo-6","PageNotFoundContainer":"ErrorPage_PageNotFoundContainer__EmLOp","subHeading":"ErrorPage_subHeading__lxX-i"};